import { useMemo } from 'react'
import { z } from 'zod'

import Columns from '@nxt-insurance/ui-kit/components/layoutComponents/Columns'
import type { Space } from '@nxt-insurance/ui-kit/types'

import type { HorizontalAlignment } from '@/cms/helperTypes'
import { horizontalAlignmentEnum, spaceEnum } from '@/cms/helperTypes'
import { BlockContent } from '@/components/renderers/BlockContent'
import type { PortableTextTypeComponentProps } from '@portabletext/react'

const inlineColumns = z.object({
  _type: z.literal('inlineColumns'),
  collapseOnMobile: z.boolean().optional(),
  maxWidth: z.string().optional(),
  columnSpace: spaceEnum.optional(),
  columns: z
    .array(
      z.object({
        _key: z.string(),
        alignHorizontally: horizontalAlignmentEnum.optional(),
        space: spaceEnum.optional(),
        content: z.array(z.unknown()),
      })
    )
    .optional(),
})

export const InlineColumns = (props: {
  node: PortableTextTypeComponentProps<unknown>
  width: number
  alignHorizontallyDefault: HorizontalAlignment
  spaceDefault: Space
  sectionName: string
}) => {
  const value = useMemo(() => inlineColumns.parse(props.node.value), [props.node.value])
  const { columns, columnSpace, collapseOnMobile, maxWidth } = value
  if (!columns) {
    return null
  }
  return (
    <Columns
      className="w-full"
      space={columnSpace ?? 'medium'}
      // @ts-expect-error
      style={{ maxWidth: maxWidth }}
      collapsable={collapseOnMobile ?? true}
      collapsedSpace="gutter"
    >
      {columns.map((col) => (
        <BlockContent
          blocks={col.content}
          align={col.alignHorizontally || props.alignHorizontallyDefault}
          space={col.space || props.spaceDefault}
          width={Math.round(props.width / columns.length)}
          sectionName={props.sectionName}
          key={`inline-cols-${col._key}`}
        />
      ))}
    </Columns>
  )
}
